module.exports = __webpack_public_path__ + "static/media/C_7.98518116.png";